import React, {  useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Divider,
  Grid,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import Logo from "../../assets/back.png";

// for videos
interface VideoData {
  id: number;
  src: string;
  title: string;
  poster: string;
}

const LigerFinal: React.FC = () => {
    const isMobile = useMediaQuery("(max-width:820px)");
  
  const [selectedVideo, setSelectedVideo] = useState<number>(0);

  const finalVideo = [
    {
      id: 1,
      src: "https://clinicalvisuals.s3.amazonaws.com/medical/liger/videos/iris_device_v4_with_subtitles.mp4",
      poster:
        "https://clinicalvisuals.s3.amazonaws.com/medical/liger/images/latest/3.png",
      title: "Iris system by Liger V4 with subtitle",
    },
    {
      id: 2,
      src: "https://clinicalvisuals.s3.amazonaws.com/medical/liger/videos/iris_device_v4_without_subtitles.mp4",
      poster:
        "https://clinicalvisuals.s3.amazonaws.com/medical/liger/images/latest/3.png",
      title: "Iris system by Liger V4 without subtitle",
    },
  ];

  const videos: VideoData[] = finalVideo || [];

  const [isVideo, setVideo] = useState<VideoData | null>(videos[0]);

  const handleVideoClick = (video: VideoData, videoIndex: number) => {
    setSelectedVideo(videoIndex);
    setVideo(video);
  };

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        aria-label="Logo Background"
        sx={{
          opacity: 0.2,
          position: "absolute",
          background: `url(${Logo}) repeat`,
          width: "100%", // Limit the width to control how many times the image repeats
          height: "100% !important", // Set the height of the container
        }}
      />
      <Grid container>
        <Grid
          item
          md={12}
          xs={12}
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            zIndex: "1",
          }}
        >
          <Box display="flex" p={2} width={ isMobile ? "100%" : "80%"} mt={4}>
            {/* Left Sidebar */}
            <Grid container>
                <Grid item md={2} sm={12} xs={12} sx={{mb:2, mt:2, pt:isMobile ? 4 : 2}}>
                    <Box
                        className = "finalProduct"
                        width="100%"
                        // bgcolor="grey.300"
                        bgcolor="#d1d1d191"
                        box-shadow="1px 2px 3px #b9b9b9"
                        p={1}
                        display="flex"
                        flexDirection={isMobile ? "row" : "column"}
                    >
                        <Box sx={{ position: isMobile ? 'absolute' : 'relative'}}>
                        <Typography variant="h6" sx={{  color: "#000" }}>
                            VIDEOS
                        </Typography>
                        </Box>
                        <Divider sx={{ mb: 2, borderColor: "#000" }} />
                        {videos.map((video, index) => (
                        <Card
                            className= {selectedVideo ? "active" : ""}
                            sx={{ padding:'5px',backgroundColor: selectedVideo === index ? '#1976d2' : 'transparent', mb: isMobile ? 1 : 2, mt: isMobile ? 4 : 2, position:'relative', width: isMobile ? '43vw' : '100%'}}
                            onClick={() => handleVideoClick(video, index)} // Handle click event

                        >
                            
                            <CardMedia
                                component="img"
                                height="120"
                                image={video.poster} // Replace with the actual image path
                                alt={video.title}
                            />
                            <CardContent sx={{ backgroundColor: selectedVideo === index ? '#1976d2' : "#eeeeee", color: selectedVideo === index ? '#fff' : "#000",  padding: isMobile ? "5px !important" : "10px"  }}>
                            <Tooltip title={video.title}>
                                <Typography variant="body1" sx={{ fontSize: "16px" }}>
                                        {video.title}
                                </Typography>
                            </Tooltip>
                            </CardContent>
                        </Card>
                        ))}
                    </Box>
                </Grid>
                <Grid item md={10} sm={12} xs={12}>
                {/* Main Content */}
                    <Box
                        flex={1}
                        ml={isMobile ? 0 : 2}
                        sx={{
                            width:'100%',
                            backgroundColor: "#f5f5f5",
                            boxShadow: "2px 1px 11px rgb(0 0 0 / 29%)",
                        }}
                    >
                        {/* Video Section */}
                        <Typography
                        variant="h6"
                        sx={{
                            padding: 2,
                            fontSize: isMobile ? "13px" : "15px",
                            fontWeight: "bold",
                            marginBottom: "-5px",
                            position: "relative",
                            backgroundColor: "#1976d2",
                            color: "white",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            textAlign: "center",
                        }}
                        >
                        {isVideo?.title}
                        </Typography>
                        <Card>

                        <MediaPlayer
                            key={isVideo?.id}
                            id={`videoslider${isVideo?.id}`}
                            style={{ display: "flex" }}
                            className="carouselvideo"
                            src={isVideo?.src}
                            viewType="video"
                            streamType="on-demand"
                            logLevel="warn"
                            crossOrigin
                            playsInline
                            autoPlay
                            // download
                            title={isVideo?.title}
                            poster={isVideo?.poster}
                        >
                            <MediaProvider>
                            </MediaProvider>
                            <DefaultVideoLayout icons={defaultLayoutIcons} />
                        </MediaPlayer>
                        <div
                            style={{
                            position: "absolute",
                            top: isMobile ? "20px" : "50px",
                            right: isMobile ? "20px" : "50px",
                            zIndex: 10,
                            }}
                        >
                            <a
                            href="https://clinicalvisuals.s3.amazonaws.com/medical/liger/videos/IRIS%20System%20by%20Liger%20Medical-2025.zip"
                            download
                            style={{
                                display: "inline-block",
                                padding: "12px 16px",
                                fontSize: "16px",
                                color: "#fff",
                                backgroundColor: "#1976d2",
                                textDecoration: "none",
                                borderRadius: "4px",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            }}
                            >
                            Download all videos
                            </a>
                        </div>
                        </Card>
                    </Box>
                </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {/* </Container> */}
    </Box>
  );
};
export default LigerFinal;
